import ConstantsStorage from '../../constants/index';
import CommonAPI from '../../api/common';
import {NotificationError, NotificationSuccess} from '../../services/notifications';
import {ActionLoadingUpdate} from './actions-loading';
import {ActionModalHide} from './actions-modal';
import {t} from '../../services/i18nHandler';

const Constants = ConstantsStorage();

export function ActionStoreServerData(key, data, remember) {
  return {
    type: Constants.DATA_ACTIONS.UPDATE,
    key,
    data,
    remember,
  };
}

export function ActionClearServerData() {
  return {
    type: Constants.DATA_ACTIONS.CLEAR,
    data: {},
  };
}

export function ActionGetUserFiles() {
  return (dispatch, getState) => {
    CommonAPI.getUserFiles().then((res) => {
      const state = getState();
      const userData = state.rUser || {};
      const userId = userData._id;
      const serverData = state.rServerData || {};
      const stateUserFiles = serverData.userFiles || {};
      const newUserFiles = {...stateUserFiles};
      newUserFiles[userId] = res;
      dispatch(ActionStoreServerData('userFiles', newUserFiles));
    }).catch((error) => {
      NotificationError(error.error_description || error.message);
    }).finally(() => {
    });
  };
}

export function ActionUpdateUserFile(fileId, fileName) {
  return (dispatch) => {
    CommonAPI.updateUserFile(fileId, fileName).then((res) => {
      dispatch(ActionGetUserFiles());
    }).catch((error) => {
      NotificationError(error.error_description || error.message);
    }).finally(() => {
    });
  };
}

export function ActionUploadPortfolioFile(file, fileName) {
  return (dispatch) => {
    dispatch(ActionLoadingUpdate('uploadPortfolioFileLoading', true));
    CommonAPI.uploadUserFile(file).then((res) => {
      NotificationSuccess('Файл успешно загружен');
      dispatch(ActionModalHide());
      if (res._id && fileName) {
        dispatch(ActionUpdateUserFile(res._id, fileName));
      } else {
        dispatch(ActionGetUserFiles());
      }
    }).catch((error) => {
      NotificationError(error.error_description || error.message);
    }).finally(() => {
      dispatch(ActionLoadingUpdate('uploadPortfolioFileLoading', false));
    });
  };
}

export function ActionGetVideoRecords(videoRecordId) {
  return (dispatch) => {
    CommonAPI.getVideoRecords(videoRecordId).then((res) => {
      if (videoRecordId) {
        dispatch(ActionStoreServerData('videoRecord', res));
      } else {
        dispatch(ActionStoreServerData('videoRecords', res));
      }
    }).catch((error) => {
      NotificationError(error.error_description || error.message);
    }).finally(() => {
    });
  };
}

export function ActionGetContacts() {
  return (dispatch) => {
    dispatch(ActionLoadingUpdate('contactsLoading', true));
    CommonAPI.getContacts().then((res) => {
      dispatch(ActionStoreServerData('contacts', res));
    }).catch((error) => {
      NotificationError(error.error_description || error.message);
    }).finally(() => {
      dispatch(ActionLoadingUpdate('contactsLoading', false));
    });
  };
}

export function ActionGetFavoriteContacts() {
  return (dispatch) => {
    dispatch(ActionLoadingUpdate('favoriteContactsLoading', true));
    CommonAPI.getFavoriteContacts().then((res) => {
      dispatch(ActionStoreServerData('favoriteContacts', res));
    }).catch((error) => {
      NotificationError(error.error_description || error.message);
    }).finally(() => {
      dispatch(ActionLoadingUpdate('favoriteContactsLoading', false));
    });
  };
}

export function ActionGetRecentContacts() {
  return (dispatch) => {
    dispatch(ActionLoadingUpdate('recentContactsLoading', true));
    CommonAPI.getRecentContacts().then((res) => {
      dispatch(ActionStoreServerData('recentContacts', res));
    }).catch((error) => {
      NotificationError(error.error_description || error.message);
    }).finally(() => {
      dispatch(ActionLoadingUpdate('recentContactsLoading', false));
    });
  };
}

export function ActionGetUsersList(params, storeVariableData = 'usersList') {
  return (dispatch) => {
    dispatch(ActionLoadingUpdate('usersListLoading', true));
    CommonAPI.getUsersList(params).then((res) => {
      dispatch(ActionStoreServerData(storeVariableData, res));
    }).catch((error) => {

      NotificationError(error.error_description || error.message);
    }).finally(() => {
      dispatch(ActionLoadingUpdate('usersListLoading', false));
    });
  };
}

export function ActionGetUsersPublicList(filter, storeVariableData = 'usersList') {
  return (dispatch) => {
    dispatch(ActionLoadingUpdate('usersListLoading', true));
    CommonAPI.getUsersPublicList(filter).then((res) => {
      dispatch(ActionStoreServerData(storeVariableData, res));
    }).catch((error) => {

      NotificationError(error.error_description || error.message);
    }).finally(() => {
      dispatch(ActionLoadingUpdate('usersListLoading', false));
    });
  };
}

export function ActionGetPublicUserData(userId) {
  return (dispatch, getState) => {
    CommonAPI.getPublicUsersData(userId).then((res) => {

      const state = getState();
      const serverData = state.rServerData || {};
      const stateUsersData = serverData.usersData || {};
      const newUsersData = {...stateUsersData};
      newUsersData[userId] = res;
      dispatch(ActionStoreServerData('usersData', newUsersData));
    }).catch((error) => {

      NotificationError(error.error_description || error.message);
    }).finally(() => {
    });
  };
}

export function ActionAddUserToContacts(userId, callback = () => {}) {
  return (dispatch, getState) => {
    const userState = getState().rUser;
    const id = userState._id;
    CommonAPI.addUserToContacts(id, userId).then((res) => {

      callback();
    }).catch((error) => {

      NotificationError(error.error_description || error.message);
    }).finally(() => {
    });
  };
}

export function ActionChangeVideoRecordType(type, videoRecordId) {
  return (dispatch, getState) => {
    CommonAPI.changeVideoRecordType(type, videoRecordId).then((res) => {

      const state = getState().rServerData || {};
      const videoRecordsData = state.videoRecords || [];
      const newVideoRecordsData = videoRecordsData.map((vs) => {
        if (vs._id === res._id) {
          return res;
        }
        return vs;
      });
      dispatch(ActionStoreServerData('videoRecords', newVideoRecordsData));
    }).catch((error) => {

      NotificationError(error.error_description || error.message);
    }).finally(() => {
    });
  };
}

export function ActionDeleteVideoRecord(videoRecordId) {
  return (dispatch) => {
    CommonAPI.deleteVideoRecord(videoRecordId).then(() => {
      dispatch(ActionGetVideoRecords());
    }).catch((error) => {

      NotificationError(error.error_description || error.message);
    }).finally(() => {
    });
  };
}

export function ActionShareEmailVideoRecord(data, videoRecordId) {
  return (dispatch) => {
    CommonAPI.shareEmailVideoRecord(data, videoRecordId).then((res) => {

      dispatch(ActionModalHide());
      NotificationSuccess(t('common.sendSuccess'));
    }).catch((error) => {

      NotificationError(error.error_description || error.message);
    }).finally(() => {
    });
  };
}

export function ActionCreateSupport(data, isFormData, callback = () => {}) {
  return (dispatch) => {
    CommonAPI.createSupport(data, isFormData).then((res) => {

      NotificationSuccess(t('common.sendSuccess'));
      callback();
    }).catch((error) => {

      NotificationError(error.error_description || error.message);
    }).finally(() => {
    });
  };
}

export function ActionGetAllTransactions() {
  return (dispatch) => {
    CommonAPI.getAllTransactions().then((res) => {
      dispatch(ActionStoreServerData('transactions', res));
    }).catch((error) => {
      NotificationError(error.error_description || error.message);
    }).finally(() => {
    });
  };
}

export function ActionSendRefundRequest(refundData, transactionId, isFormData, callback = () => {}) {
  return (dispatch) => CommonAPI.refundTransaction(refundData, transactionId, isFormData).then((res) => {
    NotificationSuccess('Заявка на возврат денежных средств');
    callback();
  }).catch((error) => {
    NotificationError(error.error_description || error.message);
  }).finally(() => {
  });
}

export function ActionShareUserPortfolio(data) {
  return (dispatch, getState) => {
    const state = getState();
    const userData = state.rUser || {};
    const userId = userData._id;
    return CommonAPI.shareUserPortfolio(data, userId).then((res) => {
      dispatch(ActionModalHide());
      NotificationSuccess(t('common.sendSuccess'));
    }).catch((error) => {
      NotificationError(error.error_description || error.message);
    }).finally(() => {
    });
  };
}
